import React, { useEffect, useState } from "react";
import useAnalytics from "./AnalyticsHook";
import MonthlyUsageChart from "./MonthlyUsageChart";
import WidgetPageWrapper from "./WidgetPageWrapper";
import { Spinner } from "react-bootstrap";

const MonthlyUsagePage = () => {
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const { FetchAnalyticsData } = useAnalytics();

  const [analyticsSessionHistories, setAnalyticsSessionHistories] = useState(
    []
  );
  // const [analyticsCurrentMonthCode, setAnalyticsCurrentMonthCode] = useState([]);
  // const [analyticsActiveUsers, setAnalyticsActiveUsers] = useState([]);

  useEffect(async () => {
    try {
      setAnalyticsLoading(true);

      var responseData = await FetchAnalyticsData();

      // setAnalyticsCurrentMonthCode(responseData.currentMonthCode);
      setAnalyticsSessionHistories(responseData.sessionHistories);
      // setAnalyticsActiveUsers(responseData.activeUsers);
    } catch (error) {
      console.log(error);
    } finally {
      setAnalyticsLoading(false);
    }
  }, []);

  return (
    <>
      <WidgetPageWrapper title={"Monthly Usage"}>
        {analyticsLoading ? (
          <Spinner />
        ) : (
          <MonthlyUsageChart
            analyticsData={analyticsSessionHistories}
            mode={"page"}
          />
        )}
      </WidgetPageWrapper>
    </>
  );
};

export default MonthlyUsagePage;
